// extracted by mini-css-extract-plugin
export default {"switch":"Switch_switch__sC-9+","slider":"Switch_slider__R2j6R","unsubSwitch":"Switch_unsubSwitch__tZ+jq"};